export default {
  Id: '',
  Brand: '',
  LastFourDigits: '',
  ThumbUrl: '',
  Principal: false,
};
